import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AppLayout from '../components/AppLayout';
import { Palette, Package, CheckCircle, Clock, XCircle } from 'lucide-react';
import '../styles/Buttons.css';

const Customization: React.FC = () => {
  const navigate = useNavigate();
  const { workspaceId } = useParams<{ workspaceId: string }>();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    setLoading(false);
  }, [workspaceId]);

  const handleBackToWorkspaces = () => {
    navigate('/workspaces');
  };

  const customizationStats = [
    {
      title: 'Active Selections',
      value: '0',
      icon: Package,
      color: '#48182F'
    },
    {
      title: 'Approved',
      value: '0',
      icon: CheckCircle,
      color: '#10B981'
    },
    {
      title: 'Pending Review',
      value: '0',
      icon: Clock,
      color: '#F59E0B'
    },
    {
      title: 'Declined',
      value: '0',
      icon: XCircle,
      color: '#EF4444'
    }
  ];

  return (
    <AppLayout onBack={handleBackToWorkspaces}>
      <div className="page-container">
        <div className="page-header">
          <div>
            <h1 style={{ margin: 0 }}>Customization</h1>
            <p style={{ fontSize: '14px', color: '#6B7280', margin: '8px 0 0 0' }}>
              Manage purchaser package selections and upgrade options
            </p>
          </div>
        </div>

        <div className="page-content" style={{ marginTop: '24px' }}>
          {loading ? (
            <div className="builders-loading">
              <div className="builders-loading-spinner" />
            </div>
          ) : (
            <div style={{
              background: 'white',
              borderRadius: '12px',
              padding: '24px',
              boxShadow: '0 4px 12px rgba(72, 24, 47, 0.15), 0 2px 4px rgba(72, 24, 47, 0.08)'
            }}>
              {/* Customization Stats */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '20px',
                marginBottom: '30px'
              }}>
                {customizationStats.map((card) => {
                  const IconComponent = card.icon;
                  return (
                    <div
                      key={card.title}
                      style={{
                        backgroundColor: '#F5F3F0',
                        border: '1px solid #D4CBC4',
                        borderRadius: '12px',
                        padding: '24px',
                        boxShadow: '0 2px 4px rgba(72, 24, 47, 0.08)'
                      }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                        <div>
                          <p style={{ fontSize: '14px', color: '#6B7280', margin: '0 0 8px 0' }}>
                            {card.title}
                          </p>
                          <p style={{ fontSize: '32px', fontWeight: '700', color: '#48182F', margin: 0 }}>
                            {card.value}
                          </p>
                        </div>
                        <div style={{
                          width: '56px',
                          height: '56px',
                          borderRadius: '12px',
                          backgroundColor: `${card.color}15`,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <IconComponent size={28} color={card.color} />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {/* Package Selections Section */}
              <div style={{
                backgroundColor: '#F5F3F0',
                border: '1px solid #D4CBC4',
                borderRadius: '12px',
                padding: '24px',
                marginBottom: '20px'
              }}>
                <h2 style={{
                  fontSize: '18px',
                  fontWeight: '600',
                  margin: '0 0 16px 0',
                  color: '#48182F'
                }}>
                  Package Selections
                </h2>
                <div style={{
                  textAlign: 'center',
                  padding: '40px',
                  color: '#6B7280'
                }}>
                  <Package size={48} color="#D4CBC4" style={{ margin: '0 auto 16px' }} />
                  <p>No package selections yet</p>
                  <p style={{ fontSize: '14px', marginTop: '8px' }}>
                    Purchaser selections will appear here once they start choosing packages
                  </p>
                </div>
              </div>

              {/* Upgrade Options Section */}
              <div style={{
                backgroundColor: '#F5F3F0',
                border: '1px solid #D4CBC4',
                borderRadius: '12px',
                padding: '24px'
              }}>
                <h2 style={{
                  fontSize: '18px',
                  fontWeight: '600',
                  margin: '0 0 16px 0',
                  color: '#48182F'
                }}>
                  Available Upgrades
                </h2>
                <div style={{
                  textAlign: 'center',
                  padding: '40px',
                  color: '#6B7280'
                }}>
                  <Palette size={48} color="#D4CBC4" style={{ margin: '0 auto 16px' }} />
                  <p>No upgrade options configured</p>
                  <p style={{ fontSize: '14px', marginTop: '8px' }}>
                    Configure packages and options in the Package Center to enable customization
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </AppLayout>
  );
};

export default Customization;
